<template>
  <Wrapper>
    <main class="main">
      <ol class="breadcrumb-trail__list">
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/${langPath}` }"
            class="breadcrumb-trail__list--item__link"
          >
            TOP
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/${langPath}contact` }"
            class="breadcrumb-trail__list--item__link"
          >
            {{ Contact.title[lang] }}
          </router-link>
        </li>
      </ol>
      <h1 class="page-title">
        {{ Contact.title[lang] }}
      </h1>
      <section class="contact-section">
        <p class="sentence">
          {{ Contact.event.title[lang] }}
        </p>
        <figure v-if="lang === 'ja'" class="contact-section__chatbot">
          <img
            class="chatbot-img"
            src="../../../assets/images/chatbot-black.png"
            alt="Chat bot black"
            width="64"
            height="64"
          />
          <figcaption class="contact-section__chatbot--description"
            >画面右下にある"チャットボット"を<br />クリックしてお気軽にご質問ください。</figcaption
          >
        </figure>
        <p
          class="sentence"
          v-for="(detail, index) in Contact.event.details"
          :key="`first-${index}`"
        >
          {{ detail[lang] }}
        </p>
        <p class="sentence contact-section__runkeeper">
          {{ Contact.runkeeper.title[lang] }}
        </p>
        <p
          class="sentence"
          v-for="(detail, index) in Contact.runkeeper.details"
          :key="`second-${index}`"
        >
          {{ detail[lang] }}
        </p>
      </section>
    </main>
  </Wrapper>
</template>

<script>
import Wrapper from "../../../components/sp/Wrapper";
import Contact from "../../../assets/constants/contact/contact";
export default {
  computed: {
    Contact: function () {
      return Contact;
    },
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  components: {
    Wrapper,
  },
  name: "Contact",
};
</script>

<style scoped>
.main {
  .page-title {
    margin: 40px 0 0 0;
    line-height: 1.25;
    padding: 0 0 0 15px;
    border-left: solid 8px var(--defaultBlackColor);
    font-size: 32px;
    font-weight: 900;
  }
  .contact-section {
    margin: 40px 0 0 0;
    font-size: 14px;
    .sentence {
      line-height: 1.6;
    }
    &__chatbot {
      margin: 12px 0 0 0;
      display: flex;
      align-items: center;
      &--description {
        margin: 12px 0 0 12px;
        line-height: 2;
      }
    }
    &__runkeeper {
      margin: 20px 0 0 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/sp/contact/Contact.vue